import React, { useState, useEffect, useCallback } from 'react';
import styles from './index.module.sass';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../../SectionTitle';
import OrderCardAwards from './OrderCardAwards';
import getPremios from '../../Queries/getPremios';
import postPremios from '../../Queries/postPremios';
import Alert from '../../Alert';

const Award = (props) => {
  const { device, setSessionMessage } = props;
  const { screenSize } = device;
  const [resultAwards, saveResultAward] = useState([]);
  const [listAwards, saveListAward] = useState([]);
  const [show, setShow] = useState(true);
  const { t } = useTranslation('awards');
  const [message, setmessage] = useState('');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);

  const Show = useCallback(async () => {
    const response = await getPremios();
    const { getdescIntvresult = [], tipoMensaje = 'error', mensaje = '' } = response;
    saveResultAward(response);
    setSessionMessage(mensaje);

    let premiosArray =
      (getdescIntvresult && getdescIntvresult.length > 0 && getdescIntvresult) || [];
    if (premiosArray.length > 0) {
      premiosArray.map((val, key) => {
        premiosArray[key].premioElegido = premiosArray[key].premiosAElegir[0].premio;
        return null;
      });
    } else {
      premiosArray = [];
    }

    saveListAward(premiosArray);
    if (tipoMensaje !== 'success') {
      setShow(false);
      setmessage(mensaje);
    }
  }, [setSessionMessage]);

  function setAltImg(event) {
    event.target.src =
      'https://webimages.terramarbrands.com.mx/images-usa/shopping-cart/cart-products-gray/preload.jpg';
  }

  async function Liberate() {
    const premioarr1 = listAwards.map((val, key) => {
      return {
        premio: listAwards[key].premiosAElegir[0].premio,
        premioaElegir: val.premioElegido,
      };
    });

    const params = {
      kit: '',
      premioarr1,
    };

    const response = await postPremios(params);
    const { postPremiosRes = {} } = response;
    setSessionMessage(postPremiosRes.mensaje);
    if (
      postPremiosRes.mensaje === 'Procesado ok ambiente:pruebas' ||
      postPremiosRes.mensaje === 'Procesado ok'
    ) {
      setAlertText(t('alertSuccess'));
      setOpen(true);
      setTimeout(() => {
        Show();
      }, 2000);
    } else {
      setAlertText(postPremiosRes.mensaje);
      setOpen(true);
    }
  }

  const changeAward = (idx, elegido) => {
    let p = [];
    listAwards[idx].premioElegido = elegido;

    for (let index = 0; index < listAwards.length; index++) {
      p.push({
        premiosAElegir: listAwards[index].premiosAElegir,
        premioElegido: listAwards[index].premioElegido,
      });
    }
    saveListAward(p);
  };

  useEffect(() => {
    Show();
  }, [Show]);

  return (
    <div id={styles.awards} className={`${styles[screenSize]} ${styles.awards}`}>
      {show ? (
        <div className={`${styles[screenSize]} ${styles.award}`}>
          <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
          <SectionTitle title={t('title')} subtitle='' />
          <div className={screenSize !== 'phone' ? styles.container : styles.containerMobile}>
            <div
              className={
                screenSize !== 'phone' ? styles.headerContainer : styles.headerContainerMobile
              }>
              <div
                className={screenSize !== 'phone' ? styles.widthHeader : styles.widthHeaderMobile}>
                <OrderCardAwards>
                  <div className={screenSize !== 'phone' ? styles.header : styles.headerMobile}>
                    <div
                      className={
                        screenSize !== 'phone' ? styles.ButtonLiberate : styles.ButtonLiberateMobile
                      }
                      onClick={Liberate}>
                      {t('titleButton')}
                    </div>
                    <div>
                      <b className={styles.letterBlue}>{t('subTitle')}: </b>
                      <label className={styles.letterGray}>{resultAwards.domicilio}</label>
                    </div>
                  </div>
                </OrderCardAwards>
              </div>
            </div>

            {listAwards.map((val, key) => {
              return (
                <div className={styles.premios} key={key}>
                  <div className={`${styles.premioContainer} ${styles[screenSize]}`}>
                    {listAwards[key].premiosAElegir.map((value, index) => {
                      return (
                        <div
                          key={index}
                          className={`${
                            index === 0
                              ? value.premio === val.premioElegido
                                ? styles.premioElegidoOne
                                : styles.premioOne
                              : value.premio === val.premioElegido
                              ? styles.premioElegido
                              : styles.premio
                          } ${styles[screenSize]}`}
                          onClick={() => changeAward(key, value.premio)}>
                          <div className={`${styles.title}  ${styles[screenSize]}`}>
                            {(value.premio === val.premioElegido && t('award')) ||
                              t('awardAlternative')}
                          </div>
                          <div
                            className={`${
                              index === 0 ? styles.datosPremio : styles.datosPremioAlt
                            } ${styles[screenSize]}`}>
                            <div
                              className={
                                index === 0 ? styles.imagenPremioPri : styles.imagenPremio
                              }>
                              <img
                                src={`https://webimages.terramarbrands.com.mx/images-usa/shopping-cart/cart-products-gray/${value.premio}.jpg`}
                                alt=''
                                className={styles.image}
                              />
                            </div>
                            <div className={styles.textPremio}>
                              <div>
                                <span
                                  className={`${index === 0 ? styles.textoPri : styles.text} ${
                                    styles[screenSize]
                                  }`}>
                                  {t('id')}: &nbsp;{value.premio}
                                </span>
                              </div>
                              {index === 0 && <div>&nbsp;</div>}

                              <div>
                                <span
                                  className={`${index === 0 ? styles.subtextPri : styles.subtext} ${
                                    styles[screenSize]
                                  }`}>
                                  {t('awardLabel')}:
                                </span>
                                <div
                                  className={`${index === 0 ? styles.spanText : styles.spanTex} ${
                                    styles[screenSize]
                                  }`}>
                                  {value.descrPremio}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className={styles.container}>
          <SectionTitle title={t('title')} subtitle='' />
          <OrderCardAwards>
            <div className={styles.message}>{message}</div>
          </OrderCardAwards>
        </div>
      )}
    </div>
  );
};

export default Award;
